import { Component, Input } from '@angular/core';
import { Terminal } from '../../shared/models';

@Component({
  selector: 'app-terminal-context',
  templateUrl: './terminal-context.component.html',
  styleUrls: ['./terminal-context.component.scss']
})
export class TerminalContextComponent {
  @Input() terminal: Terminal;

  get serviceNames(): string {
    return (this.terminal?.services || []).map(service => service.name).filter(Boolean).join(' · ');
  }
}
